import React from 'react';
import { CheckCircle, Send, Download, Shield, Ban, PlayCircle, X } from 'lucide-react';

const Btn = ({ onClick, testId, hex, Icon, children }) => (
  <button onClick={onClick} data-testid={testId}
    className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full text-[11px] font-medium border transition-[background-color,transform] hover:-translate-y-px"
    style={{ background: `${hex}1f`, borderColor: `${hex}55`, color: hex }}>
    <Icon className="w-3.5 h-3.5" /> {children}
  </button>
);

export const StaffBulkBar = ({ count, canChangeRole, onMessage, onExport, onRole, onSuspend, onUnsuspend, onClear }) => (
  <div className="sticky top-3 z-20 flex items-center gap-2 px-4 py-3 rounded-2xl bg-[#0b0b18]/85 border border-cyan-400/30 flex-wrap backdrop-blur-xl shadow-[0_20px_40px_-20px_rgba(0,229,255,0.4)] animate-[jewelFadeUp_0.3s_ease-out]" data-testid="staff-bulk-bar">
    <CheckCircle className="w-4 h-4 text-cyan-300" />
    <span className="text-sm text-cyan-100 font-medium" data-testid="staff-bulk-count">{count} selected</span>
    <div className="flex-1" />
    <Btn onClick={onMessage} testId="staff-bulk-message" hex="#00E5FF" Icon={Send}>Message</Btn>
    <Btn onClick={onExport} testId="staff-bulk-export" hex="#06B6D4" Icon={Download}>Export</Btn>
    {canChangeRole && <Btn onClick={onRole} testId="staff-bulk-role" hex="#A78BFA" Icon={Shield}>Change role</Btn>}
    <Btn onClick={onSuspend} testId="staff-bulk-suspend" hex="#F43F5E" Icon={Ban}>Suspend</Btn>
    <Btn onClick={onUnsuspend} testId="staff-bulk-unsuspend" hex="#10B981" Icon={PlayCircle}>Reactivate</Btn>
    <button onClick={onClear} data-testid="staff-bulk-clear" className="p-1.5 text-white/40 hover:text-white transition-colors"><X className="w-4 h-4" /></button>
  </div>
);
